import ShowSearchResults from './ShowSearchResults'

export default ShowSearchResults
